<template>
	<div class="accessories-list">
		<hr >
		<h3 class="accessories-list-heading">
			Accessories
		</h3>
		<hr >
		<template v-if="selectedStorage && selectedStorage.id">
			<storage-item />
			<hr >
		</template>
		<template v-for="(accessory, type) in cartAccessories">
			<template v-for="item in accessory">
				<template v-if="getAccessory(item, type)">
					<accessory-item
						:key="`list-accessory-${item.products_id}-${item.id}`"
						:accessory="getAccessory(item, type)"
						:type="type"
					/>
					<hr :key="`list-hr-${item.products_id}-${item.id}`" >
				</template>
			</template>
		</template>
		<template v-if="hasNoAccessories">
			<p class="no-items">
				No accessories were selected.
			</p>
			<hr >
		</template>
	</div>
</template>

<script>
import { mapState } from "vuex";
import AccessoryItem from "./accessory-item";
import StorageItem from "./storage-item";

export default {
	name: "AccessoriesList",
	components: {
		AccessoryItem,
		StorageItem
	},
	props: {
		which: {
			type: String,
			required: true
		}
	},
	computed: {
		...mapState({
			accessories: state => state.StarterPc.accessories,
			cart: state => state.StarterPc.cart,
			selectedStorage: state => state.StarterPc.selectedStorage
		}),
		cartAccessories() {
			const puck = this.cart.extras.find(
				extra => extra.product_class == "puck"
			);
			const streamingBundle =
				(this.cart.streamingBundle.id && [this.cart.streamingBundle]) || [];
			const peripherals =
				(this.cart.peripherals[0].id && this.cart.peripherals) || [];
			const monitors = (this.cart.monitors[0].id && this.cart.monitors) || [];
			const extras = (puck && [puck]) || [];
			const specials = this.cart.specials || [];

			return {
				streamingBundle,
				peripherals: _.sortBy(peripherals, "name"),
				monitors: _.sortBy(monitors, "name"),
				extras: _.sortBy(extras, "name"),
				specials
			};
		},
		hasNoAccessories() {
			return (
				!this.cartAccessories.peripherals.length &&
				!this.cartAccessories.monitors.length &&
				!this.cartAccessories.streamingBundle.length &&
				!(this.selectedStorage && this.selectedStorage.id) &&
				!this.cartAccessories.extras.length
			);
		}
	},
	methods: {
		getAccessory(accessory, type) {
			return (
				this.accessories[type] &&
				this.accessories[type].find(item => item.id == accessory.products_id)
			);
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.accessories-list {
	&-heading {
		color: $black;
		margin: 33px 0 33px 25px;

		@media (min-width: 320px) and (max-width: 580px) {
			margin: 33px 0 33px 0;
		}
	}

	.no-items {
		margin: 33px 0 33px 65px;
	}
}

hr {
	border-top: 1px solid #dadde0;
	margin: 0;
}
</style>
